import React, { useRef, useState } from "react";
import { uploadFileToCatalog, deleteFileById } from "../../services/CatalogService";
import notification from "../Notification";

const LogoUploadDangerZone = ({ formik }) => {
  const fileInputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const handleUploadFile = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const uploaded = await uploadFileToCatalog(file);
    formik.setFieldValue("logoUrl", {
      id: uploaded.id,
      url: uploaded.url,
    });
      notification("success", "Logo subido exitosamente", "");
      if (fileInputRef.current) fileInputRef.current.value = null;
    } catch (err) {
      notification("error", "Error al subir el archivo", "");
    } finally {
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleUploadFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDelete = async () => {
    if (!formik.values.logoUrl?.id) return;
    try {
      await deleteFileById(formik.values.logoUrl.id);
      formik.setFieldValue("logoId", null);
      formik.setFieldValue("logoUrl", null);
      notification("success", "Logo eliminado exitosamente", "");
      if (fileInputRef.current) fileInputRef.current.value = null;
    } catch (err) {
      notification("error", "Error al eliminar el logo", "");
    }
  };
  //console.log("logoUrl xd:  ", formik.values.logoUrl);

  return (
    <div className="col-sm-8">
      <div
        className="border rounded p-3 text-center"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        style={{
          borderStyle: "dashed",
          backgroundColor: "#e8e6e6",
          cursor: "pointer",
        }}
        onClick={() => fileInputRef.current.click()}
      >
        <h6 className="text mb-2">Arrastra tu Logo</h6>

        {formik.values.logoUrl ? (
          <div className="mb-2">
            <img
              src={formik.values.logoUrl.url}
              alt="Logo actual"
              style={{
                maxWidth: "100%",
                maxHeight: "100px",
                height: "auto",
                width: "auto",
                objectFit: "contain",
              }}
            />
          </div>
        ) : (
          <p className="text-muted">
            Arrastra y suelta una imagen aquí o haz clic para seleccionar
          </p>
        )}

        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          className="d-none"
          onChange={(e) => handleUploadFile(e.target.files[0])}
          disabled={uploading}
        />

        {formik.values.logoUrl && (
          <button
            type="button"
            className="btn btn-sm btn-outline-danger mt-2"
            onClick={(e) => {
              e.stopPropagation(); // <- esto es clave
              handleDelete();
            }}
            disabled={uploading}
          >
            Eliminar
          </button>
        )}
      </div>
    </div>
  );
};

export default LogoUploadDangerZone;
